import React from "react";
import LegalDoc from "../components/Layout/LegalDoc";
import useSEO from "../hooks/useSEO";

const PrivacyPolicy = () => {
  useSEO({
    title: "Privacy Policy",
    description:
      "How MandapAI collects, uses and protects your data across our marketplace, website and mobile app.",
    path: "/privacy",
  });
  return (
  <LegalDoc
    title="Privacy Policy"
    updated="June 7, 2026"
    intro="MandapAI ('we', 'us', 'our') is committed to protecting your privacy. This policy explains what information we collect, how we use it, and the choices you have when you use our marketplace, website, and mobile app."
    sections={[
      {
        heading: "Information We Collect",
        body: [
          "Account details you provide — name, email, phone number, and business information when you register as a vendor or customer.",
          "Booking and transaction data, including events, services requested, and payment status.",
          "Documents you upload for verification (such as GSTIN or business licenses).",
          "Usage and device information collected automatically, such as IP address, browser type, and pages visited.",
        ],
      },
      {
        heading: "How We Use Your Information",
        body: [
          "To create and manage your account and provide our services.",
          "To connect customers with vendors and process bookings and payments.",
          "To verify vendor businesses and maintain trust and safety on the platform.",
          "To send service updates, booking alerts, and (with your consent) marketing communications.",
          "To improve our products, personalize recommendations, and analyze usage.",
        ],
      },
      {
        heading: "Sharing of Information",
        body: [
          "Between customers and vendors as needed to fulfil a booking.",
          "With service providers who help us operate the platform (payments, hosting, analytics) under appropriate confidentiality obligations.",
          "When required by law, regulation, or valid legal process.",
        ],
      },
      {
        heading: "Data Security",
        body: "We use industry-standard technical and organizational measures to protect your information. No method of transmission or storage is fully secure, but we work continuously to safeguard your data.",
      },
      {
        heading: "Your Rights",
        body: [
          "Access, correct, or update your personal information from your account settings.",
          "Request deletion of your account and associated data, subject to legal retention requirements.",
          "Opt out of marketing communications at any time.",
        ],
      },
      {
        heading: "Cookies",
        body: "We use cookies and similar technologies to keep you signed in, remember preferences, and understand how the site is used. You can control cookies through your browser settings.",
      },
      {
        heading: "Children's Privacy",
        body: "Our services are intended for users aged 18 and over. We do not knowingly collect personal information from children.",
      },
      {
        heading: "Changes to This Policy",
        body: "We may update this policy from time to time. Material changes will be posted on this page with an updated revision date.",
      },
    ]}
  />
  );
};

export default PrivacyPolicy;
